var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "order-item",
      on: {
        click: function($event) {
          return _vm.$emit("choose", _vm.order.orderNumber)
        }
      }
    },
    [
      _c("div", { staticClass: "number" }, [
        _vm._v("\n    " + _vm._s(_vm.order.orderNumber) + "\n    "),
        _c("span", [
          _vm._v("от " + _vm._s(_vm._f("fullDate")(_vm.order.createdAt)))
        ])
      ]),
      _c("div", { staticClass: "status" }, [
        _c("span", [_vm._v("Статус")]),
        _c("div", { class: { warning: _vm.status === "Отменен" } }, [
          _vm._v("\n      " + _vm._s(_vm.status) + "\n    ")
        ])
      ]),
      _c("div", { staticClass: "delivery" }, [
        _c("span", [_vm._v("Доставка")]),
        _c("div", [_vm._v("\n      " + _vm._s(_vm.delivery) + "\n    ")])
      ]),
      _c("div", { staticClass: "payment" }, [
        _c("span", [_vm._v("Оплата")]),
        _c("div", [_vm._v("\n      " + _vm._s(_vm.payment) + "\n    ")])
      ]),
      _c("div", { staticClass: "price price-rub" }, [
        _c("span", [_vm._v("Сумма")]),
        _vm._v("\n    " + _vm._s(_vm._f("price")(_vm.order.subtotal)) + "\n  ")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }